import type { JSONContent } from '@tiptap/core';
import { produce } from 'immer';

const updateNodeText = (node: JSONContent, newText: string) => {
  return produce(node, (draft) => {
    if (draft.content) {
      draft.content = draft.content.map((contentItem) => {
        contentItem.text = newText;
        return contentItem;
      });
    }
  });
};

export { updateNodeText };
